export default {"src":"/_next/static/media/community-dog.5394da4a.svg","height":329,"width":403,"blurWidth":0,"blurHeight":0};